import { render, staticRenderFns } from "./HeaderTop2.vue?vue&type=template&id=cfdf4d5a"
import script from "./HeaderTop2.vue?vue&type=script&lang=js"
export * from "./HeaderTop2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports